const formatDetailValue = (detail) => {
  if (typeof detail === "string") return detail.trim();
  if (Array.isArray(detail)) {
    return detail
      .map((item) => {
        if (typeof item === "string") return item;
        if (item && typeof item === "object") {
          return item.msg || item.message || JSON.stringify(item);
        }
        return "";
      })
      .filter(Boolean)
      .join(" ");
  }
  if (detail && typeof detail === "object") {
    return detail.message || detail.msg || JSON.stringify(detail);
  }
  return "";
};

function humanizeKnownMessage(message) {
  const low = String(message || "").toLowerCase();
  if (
    low.includes("rolearn") &&
    (low.includes("parameter validation failed") || low.includes("invalid length"))
  ) {
    return "Please enter a valid IAM Role ARN (arn:aws:iam::<account-id>:role/<role-name>).";
  }
  return message;
}

export function parseApiErrorMessage(errorBody, fallback = "Request failed.") {
  if (errorBody == null || errorBody === "") {
    return fallback;
  }

  if (typeof errorBody === "string") {
    const trimmed = errorBody.trim();
    if (!trimmed) return fallback;
    try {
      return parseApiErrorMessage(JSON.parse(trimmed), fallback);
    } catch {
      return humanizeKnownMessage(trimmed);
    }
  }

  if (typeof errorBody === "object") {
    const nestedMessage = errorBody?.error?.message;
    const detail = formatDetailValue(errorBody?.detail);
    const topMessage = typeof errorBody?.message === "string" ? errorBody.message.trim() : "";

    const resolved =
      (typeof nestedMessage === "string" && nestedMessage.trim()) ||
      detail ||
      topMessage ||
      fallback;
    return humanizeKnownMessage(resolved);
  }

  return fallback;
}

export async function readApiError(response, fallback = "Request failed.") {
  let body = "";
  try {
    body = await response.text();
  } catch {
    body = "";
  }

  const message = parseApiErrorMessage(body, fallback);
  const error = new Error(message);
  error.status = response?.status;
  error.responseBody = body;
  return error;
}

export default parseApiErrorMessage;
